import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { Button, Input, Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";

function AdminSingleLeaguePage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const leagueUid = params.leagueUid;

  const [leagueObject, setLeagueObject] = useState();
  const [name, setName] = useState();
  const [nextOpeningDateTime, setNextOpeningDateTime] = useState();
  const [drivers, setDrivers] = useState();
  const [teams, setTeams] = useState();

  const fetchLeague = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "leagues"), where("uid", "==", leagueUid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      if (data.drivers) {
        setDrivers(data.drivers);
      } else if (data.teams) {
        setTeams(data.teams);
      }

      setLeagueObject(data);
      setName(data.name);
      setNextOpeningDateTime(data.nextOpeningDateTime);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching league data");
    }
  };

  useEffect(() => {
    if (leagueUid) {
      fetchLeague();
    }
    // eslint-disable-next-line
  }, [leagueUid]);

  const saveChanges = () => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this league?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const leagueRef = query(
            collection(db, "leagues"),
            where("uid", "==", leagueUid)
          );
          const findLeagues = await getDocs(leagueRef);
          findLeagues.forEach(async (league) => {
            const getLeague = doc(db, "leagues", league.id);
            await updateDoc(getLeague, {
              name: name,
              nextOpeningDateTime: nextOpeningDateTime
                ? nextOpeningDateTime
                : null,
            }).then(() => {
              fetchLeague();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  const deleteLeague = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this league?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const leagueRef = query(
            collection(db, "leagues"),
            where("uid", "==", leagueUid)
          );
          const findLeagues = await getDocs(leagueRef);
          findLeagues.forEach(async (league) => {
            const getLeagues = doc(db, "leagues", league.id);
            await deleteDoc(getLeagues);
          });

          Swal.fire({
            text: "League deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting league");
        }
      }
    });
  };

  const [addDriverModalIsOpen, setAddDriverModalIsOpen] = useState(false);

  const toggleAddDriverModal = () => {
    setAddDriverModalIsOpen(!addDriverModalIsOpen);
  };

  const [newDriverNameAndTeam, setNewDriverNameAndTeam] = useState();

  const addDriver = async () => {
    setIsLoading(true);

    try {
      const leagueRef = query(
        collection(db, "leagues"),
        where("name", "==", "Formula 1")
      );
      const findLeagues = await getDocs(leagueRef);
      findLeagues.forEach(async (league) => {
        const getLeague = doc(db, "leagues", league.id);

        const newDrivers = drivers
          ? [...drivers, { name: newDriverNameAndTeam }]
          : [{ name: newDriverNameAndTeam }];

        await updateDoc(getLeague, {
          drivers: newDrivers,
        }).then(() => {
          fetchLeague();
        });
      });

      setAddDriverModalIsOpen(false);
      setNewDriverNameAndTeam("");
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  const removeDriver = async (driver) => {
    setIsLoading(true);

    try {
      const leagueRef = query(
        collection(db, "leagues"),
        where("name", "==", "Formula 1")
      );
      const findLeagues = await getDocs(leagueRef);
      findLeagues.forEach(async (league) => {
        const getLeague = doc(db, "leagues", league.id);

        const newDrivers = drivers.filter((item) => item.name !== driver.name);

        await updateDoc(getLeague, {
          drivers: newDrivers,
        }).then(() => {
          fetchLeague();
        });
      });

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  const [addTeamModalIsOpen, setAddTeamModalIsOpen] = useState(false);

  const toggleAddTeamModal = () => {
    setAddTeamModalIsOpen(!addTeamModalIsOpen);
  };

  const [newTeamName, setNewTeamName] = useState();

  // TODO
  const addTeam = async () => {
    setIsLoading(true);

    try {
      const leagueRef = query(
        collection(db, "leagues"),
        where("uid", "==", leagueUid)
      );
      const findLeagues = await getDocs(leagueRef);
      findLeagues.forEach(async (league) => {
        const getLeague = doc(db, "leagues", league.id);

        const newTeams = teams
          ? [...teams, { name: newTeamName }]
          : [{ name: newTeamName }];

        await updateDoc(getLeague, {
          teams: newTeams,
        }).then(() => {
          fetchLeague();
        });
      });

      setAddTeamModalIsOpen(false);
      setNewTeamName("");
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  const removeTeam = async (team) => {
    setIsLoading(true);

    try {
      const leagueRef = query(
        collection(db, "leagues"),
        where("uid", "==", leagueUid)
      );
      const findLeagues = await getDocs(leagueRef);
      findLeagues.forEach(async (league) => {
        const getLeague = doc(db, "leagues", league.id);

        const newTeams = teams.filter((item) => item.name !== team.name);

        await updateDoc(getLeague, {
          teams: newTeams,
        }).then(() => {
          fetchLeague();
        });
      });

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        LEAGUE
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The league's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Next opening date
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={nextOpeningDateTime}
          onChange={(e) => setNextOpeningDateTime(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
        />
        {leagueObject?.sportCategory === "RACING" ? (
          <>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Drivers
            </p>
            <Button
              onClick={toggleAddDriverModal}
              className="primaryBtn"
              style={{ marginBottom: "1rem" }}
            >
              ADD DRIVER
            </Button>
            <Modal
              id="AddDriverModal"
              isOpen={addDriverModalIsOpen}
              toggle={toggleAddDriverModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleAddDriverModal} />
                </div>
                <div>
                  <h1>ADD DRIVER</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Name and team (e.g. Max Verstappen - Red Bull Racing)
                    </p>
                    <input
                      type="text"
                      className="mainInput"
                      value={newDriverNameAndTeam}
                      onChange={(e) => setNewDriverNameAndTeam(e.target.value)}
                      placeholder="The new driver's name and team"
                      style={{ marginBottom: "0.5rem" }}
                    />
                  </div>
                  <Button
                    onClick={addDriver}
                    className="primaryBtn"
                    style={{ marginTop: "0.5rem" }}
                    disabled={!newDriverNameAndTeam}
                  >
                    ADD
                  </Button>
                </div>
              </ModalBody>
            </Modal>
            {drivers?.length > 0 ? (
              drivers.map((driver, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "0.5rem",
                  }}
                >
                  <p style={{ marginBottom: 0 }}>{driver.name}</p>
                  <Button
                    onClick={() => removeDriver(driver)}
                    className="secondaryBtn"
                    style={{ width: 100 }}
                  >
                    REMOVE
                  </Button>
                </div>
              ))
            ) : (
              <p style={{ textAlign: "center" }}>No drivers available</p>
            )}
          </>
        ) : (
          <>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Teams
            </p>
            <Button
              onClick={toggleAddTeamModal}
              className="primaryBtn"
              style={{ marginBottom: "1rem" }}
            >
              ADD TEAM
            </Button>
            <Modal
              id="AddDriverModal"
              isOpen={addTeamModalIsOpen}
              toggle={toggleAddTeamModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleAddTeamModal} />
                </div>
                <div>
                  <h1>ADD TEAM</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Name
                    </p>
                    <input
                      type="text"
                      className="mainInput"
                      value={newTeamName}
                      onChange={(e) => setNewTeamName(e.target.value)}
                      placeholder="The new team's name"
                      style={{ marginBottom: "0.5rem" }}
                    />
                  </div>
                  <Button
                    onClick={addTeam}
                    className="primaryBtn"
                    style={{ marginTop: "0.5rem" }}
                    disabled={!newTeamName}
                  >
                    ADD
                  </Button>
                </div>
              </ModalBody>
            </Modal>
            {teams?.length > 0 ? (
              teams.map((team, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "0.5rem",
                  }}
                >
                  <p style={{ marginBottom: 0 }}>{team.name}</p>
                  <Button
                    onClick={() => removeTeam(team)}
                    className="secondaryBtn"
                    style={{ width: 100 }}
                  >
                    REMOVE
                  </Button>
                </div>
              ))
            ) : (
              <p style={{ textAlign: "center" }}>No teams available</p>
            )}
          </>
        )}
        <Button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
          disabled={
            name === leagueObject?.name &&
            nextOpeningDateTime === leagueObject?.nextOpeningDateTime
          }
        >
          SAVE
        </Button>
        <Button
          onClick={deleteLeague}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
}

export default AdminSingleLeaguePage;
